module.exports = __webpack_public_path__ + "img/trainer.f76cba56.svg";